import React from 'react';
import ratingToStars from './ratingToStars';

export default function ratingSumToStars(ratings = [], className) {
	let ratingSum = 0;
	for (let i = 0; i < ratings.length; i++) {
		ratingSum += ratings[i].rating
	}
	const average = Math.round(ratingSum / ratings.length);
	if (average) {
		return ratingToStars(average, className)
	} else {
		return <div></div>
	}
}


// WEBPACK FOOTER //
// ./src/assets/functions/ratingSumToStars.js